module.exports = __webpack_public_path__ + "static/media/check-icon.6e63f316.svg";